<template>
  <div class="footer main-bg">
    <div class="footer-content">
      <div class="footer-left">
        <p class="footer-desc gray-cl">Copyright © 2023</p>
        <div class="footer-left-bottom">
          <svg-icon
            v-for="(item, index) in socialMedia"
            :key="index"
            :iconClass="iconLight === index ? item.activeIcon : item.icon"
            :className="`icon-32 mg-24 ${iconLight === index ? 'blue-cl' : 'gray-cl'}`"
            @mouseenter="iconLight = index"
            @mouseleave="iconLight = -1"
            @click="socialMediaLink(item.link)"></svg-icon>
        </div>
      </div>
      <div class="footer-right">
        <div
          v-for="(parentItem, parentIndex) in footerList"
          :key="parentIndex"
          :class="{'mr-24': parentIndex < 3}">
          <p class="footer-text main-cl">{{ parentItem.title }}</p>
          <p class="footer-text"
            v-for="(item, index) in parentItem.list"
            :key="`${parentIndex+1}_${index+1}`"
            :class="[hoverKey === `${parentIndex+1}_${index+1}` ? 'blue-cl' : 'gray-cl', item.class || '']"
            @click="btnLink(item)"
            @mouseenter="hoverKey = `${parentIndex+1}_${index+1}`"
            @mouseleave="hoverKey = ''">{{ item.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCookie } from '@/utils';

export default {
  name: 'c-footer',
  data() {
    return {
      iconLight: -1,
      hoverKey: '',
      userSkin: getCookie('cusSkin') || getCookie('defSkin'), // 用户选择的skin
      socialMedia: [
        
      ],
    };
  },
  computed: {
    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },
    /**
     * 是否开启虚拟盘
     */
    isVirtualOpen() {
      return this.publicInfo && this.publicInfo.is_virtual_open === '1';
    },
    lan() {
      return this.$store.state.baseData.lan;
    },
    origin() {
      return window.location.origin;
    },
    footerList() {
      return [
        {
          title: this.$t('homeTemplate.footer.title_1'),
          list: [
            {
              text: this.$t('homeTemplate.footer.text_1_1'),
              linkMethod: 'zh_en_mode',
              zhLink: 'https://exchange.zendesk.com/hc/zh-sg/articles/10843646186002',
              enLink: 'https://exchange.zendesk.com/hc/en-us/articles/10843646186002',
            },
            {
              text: this.$t('homeTemplate.footer.text_1_2'),
              linkMethod: 'zh_en_mode',
              zhLink: 'https://exchange.zendesk.com/hc/zh-sg/categories/10272346094738-%E6%B4%BB%E5%8A%A8%E4%B8%AD%E5%BF%83',
              enLink: 'https://exchange.zendesk.com/hc/en-us/categories/10272346094738-Announcement',
            },
            {
              text: this.$t('homeTemplate.footer.text_1_3'),
              linkMethod: 'zh_en_mode',
              zhLink: 'https://exchange.zendesk.com/hc/zh-sg/sections/10272349924882-%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE',
              enLink: 'https://exchange.zendesk.com/hc/en-us/sections/10272349924882-Agreements',
            },
            {
              text: this.$t('homeTemplate.footer.text_1_4'),
              linkMethod: 'zh_en_mode',
              zhLink: 'https://exchange.zendesk.com/hc/zh-sg/articles/10730120215058',
              enLink: 'https://exchange.zendesk.com/hc/en-us/articles/10730120215058',
            },
            {
              text: this.$t('homeTemplate.footer.text_1_5'),
              linkMethod: 'zh_en_mode',
              zhLink: 'https://exchange.zendesk.com/hc/zh-sg/articles/10397552321682',
              enLink: 'https://exchange.zendesk.com/hc/en-us/articles/10397552321682',
            },
            {
              text: this.$t('homeTemplate.footer.text_1_6'),
              linkMethod: 'zh_en_mode',
              zhLink: 'https://exchange.zendesk.com/hc/zh-sg/articles/10272352239890',
              enLink: 'https://exchange.zendesk.com/hc/en-us/articles/10272352239890',
            },
          ],
        },
        {
          title: this.$t('homeTemplate.footer.title_2'),
          list: [
            {
              text: this.$t('homeTemplate.footer.text_2_1'),
              linkMethod: 'zh_en_mode',
              zhLink: 'https://exchange.zendesk.com/hc/zh-sg',
              enLink: 'https://exchange.zendesk.com/hc/en-us',
            },
            {
              text: this.$t('homeTemplate.footer.text_2_2'),
              linkMethod: 'zh_en_mode',
              zhLink: 'https://exchange.zendesk.com/hc/zh-sg/sections/10272522157330',
              enLink: 'https://exchange.zendesk.com/hc/en-us/sections/10272522157330-Rate-Table',
            },
            {
              text: this.$t('homeTemplate.footer.text_2_3'),
              linkMethod: 'zh_en_mode',
              zhLink: 'https://exchange.zendesk.com/hc/zh-sg/sections/10272465324306',
              enLink: 'https://exchange.zendesk.com/hc/en-us/sections/10272465324306-Perpetual-Contract',
            },
          ],
        },
        {
          title: this.$t('homeTemplate.footer.title_3'),
          list: [
          ],
        },
        {
          title: this.$t('homeTemplate.footer.title_4'),
          list: [
            {
              text: this.$t('homeTemplate.footer.text_4_2'),
              linkMethod: 'route_mode',
              link: '/futures',
            },
            {
              text: this.$t('homeTemplate.footer.text_4_1'),
              linkMethod: 'route_mode',
              link: '/trade/BTC_USDT',
            },
            {
              text: this.$t('homeTemplate.footer.text_4_3'),
              linkMethod: 'route_mode',
              link: '/otc',
            },
          ],
        },
      ];
    },
  },
  mounted() {},
  methods: {
    btnLink(item) {
      if (item.linkMethod === 'footer_udesk') {
        this.initUDesk();
        return;
      }

      let url = '';
      if (item.linkMethod === 'zh_en_mode') {
        url = this.lan === 'zh_CN' ? item.zhLink : item.enLink;
      } else if (item.linkMethod === 'origin_mode') {
        url = `${this.origin}${item.link}`;
      } else if (item.linkMethod === 'route_mode') {
        url = item.link;
      }

      if (url) {
        if (url.indexOf('http') > -1) {
          window.open(url);
        } else {
          this.$router.push(url);
        }
      }
    },

    socialMediaLink(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  padding: 100px 0 36px;
  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .footer-logo {
    height: 30px;
    margin-bottom: 8px;
  }
  .footer-desc {
    font-size: 12px;
    line-height: 20px;
  }
  .footer-left-bottom {
    margin-top: 53px;
    width: 224px;
    display: flex;
    flex-wrap: wrap;
  }
  .mg-24 {
    margin-right: 24px;
    margin-bottom: 24px;
    cursor: pointer;
  }
  .footer-right {
    display: flex;
    align-items: flex-start;
  }
  .footer-text {
    width: 180px;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 8px;
    cursor: pointer;
  }
  .mr-24 {
    margin-right: 24px;
  }
}
</style>
